 <template>
 	<div>
 	<b-container class="share-tool mb-4 mt-4">

  <b-row class="mt-3">
      <b-col class="mb-3"><b-button block variant="outline-primary" :href="'sms:?&body='+message">SMS <i class="fa fa-comments-o"></i></b-button></b-col>
	  	<b-col class="mb-3"><b-button block variant="outline-primary" :href="'https://api.whatsapp.com/send/?text=' + message +''">WhatsApp <i class="fa fa-whatsapp"></i></b-button></b-col>
	  </b-row>

	</b-container>


	
	</div>
 </template>

<script>

export default {


  props: {
    link: {
      type: String,
      default: '',
    },
    deckname: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      //message: encodeURIComponent('Check out our SizzleDeck: ' + this.link),
      message: encodeURIComponent(this.link),
    }
  },


}
</script>

<style >


</style>